const WebService = () => import('@/pages/system/web-service')

const CreateWebService = () => import('@/pages/system/web-service/create')

const EditWebService = () => import('@/pages/system/web-service/edit')

export default {
  path: 'web-service',
  meta: {
    label: 'webService',
    auth: 'webService'
  },
  component: {
    name: 'WebService',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemWebServiceReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: WebService
    },
    {
      name: 'SystemCreateWebService',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateWebService
    },
    {
      name: 'SystemEditWebService',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditWebService
    }
  ]
}
